import Flickity from 'flickity';

window.addEventListener('load', function () {
    if (typeof Flickity === 'undefined') return;

    // ----------------------------------------
    // 共通：.swipe_wrap は常にスライダー
    // ----------------------------------------
    const swipeElems = document.querySelectorAll('.swipe_wrap');

    swipeElems.forEach((elem) => {
        if (!elem) return;
        if (Flickity.data(elem)) return;

        new Flickity(elem, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true
        });
    });

    // ----------------------------------------
    // ブレイクポイント
    // ----------------------------------------
    const mqlMobile = window.matchMedia('(max-width: 480px)');
    const mqlTablet = window.matchMedia('(max-width: 840px)');

    let isMobile = mqlMobile.matches;
    let isTablet = mqlTablet.matches;

    /**
     * 条件付きスライダー処理
     */
    function handleConditionalSlider(selector, enable, options = {}) {
        const elems = document.querySelectorAll(selector);

        elems.forEach((elem) => {
            if (!elem) return;

            const instance = Flickity.data(elem);

            if (enable) {
                if (instance) return;

                new Flickity(elem, {
                    contain: true,
                    ...options
                });

            } else {
                if (instance) {
                    instance.destroy();
                }
            }
        });
    }

    // ----------------------------------------
    // 初期実行
    // ----------------------------------------
    handleConditionalSlider('.swipe_wrap_sp', isMobile, {
        cellAlign: 'center',
        pageDots: false,
        prevNextButtons: true
    });

    handleConditionalSlider('.swipe_wrap_tab', isTablet, {
        cellAlign: 'center',
        pageDots: false,
        prevNextButtons: true
    });

    // ----------------------------------------
    // リサイズ監視
    // ----------------------------------------
    window.addEventListener('resize', () => {

        const currentMobile = mqlMobile.matches;
        const currentTablet = mqlTablet.matches;

        if (currentMobile !== isMobile) {
            isMobile = currentMobile;
            handleConditionalSlider('.swipe_wrap_sp', isMobile, {
                cellAlign: 'center',
                pageDots: false,
                prevNextButtons: true
            });
        }

        if (currentTablet !== isTablet) {
            isTablet = currentTablet;
            handleConditionalSlider('.swipe_wrap_tab', isTablet, {
                cellAlign: 'center',
                pageDots: false,
                prevNextButtons: true
            });
        }

    });
});